
import axios from 'axios';

interface AuthProvider {
  signin(email: string, password: string,
    onSuccess: (access_token: string) => void,
    onError: (error: string) => void): Promise<void>;
  signout(callback: VoidFunction): Promise<void>;
}

/**
 * This represents some generic auth provider API, like Firebase.
 */
const THeachAIAuthProvider: AuthProvider = {
  async signin(email: string, password: string,
    onSuccess: (access_token: string) => void,
    onError: (error: string) => void
  ) {
    //console.log("THeachAIAuthProvider login")
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND}/auth/login`,
        new URLSearchParams({
          'grant_type': '',
          'username': email,
          'password': password,
          'scope': '',
          'client_id': '',
          'client_secret': ''
        }));
      const accessToken = data.access_token;
      onSuccess(accessToken);
      //console.log(accessToken);
    } catch (error) {
      console.error("Login failed", error);
      onError("Unable to login");
    }

  },
  async signout(callback: VoidFunction) {
    console.log("THeachAIAuthProvider signout");
    callback();
  },
};

export { THeachAIAuthProvider };